var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16223_26616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 4.16602V5.83268H4.16667V16.666H15.8333V5.83268H13.3333V4.16602H15.8333C16.7538 4.16602 17.5 4.91221 17.5 5.83268V16.666C17.5 17.5865 16.7538 18.3327 15.8333 18.3327H4.16667C3.24619 18.3327 2.5 17.5865 2.5 16.666V5.83268C2.5 4.91221 3.24619 4.16602 4.16667 4.16602H6.66667ZM10 1.66602C10.4602 1.66602 10.8333 2.03912 10.8333 2.49935V11.523L12.357 9.99935C12.6825 9.67385 13.2101 9.67385 13.5355 9.99935C13.861 10.3248 13.861 10.8524 13.5355 11.1778L10.7366 13.9768C10.3297 14.3836 9.67025 14.3836 9.26342 13.9768L6.46447 11.1778C6.13903 10.8524 6.13903 10.3248 6.46447 9.99935C6.7899 9.67385 7.31754 9.67385 7.64297 9.99935L9.16667 11.523V2.49935C9.16667 2.03912 9.53975 1.66602 10 1.66602Z",
    fill: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16223_26616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/exportIcon.7cc9b5af8e7509b4b0958e15a82dedbb.svg";
export { ForwardRef as ReactComponent };